import React from 'react';

import { FeatureCategories } from 'src/modules/designStudio/constants';
import {
  MenuItemType,
  MenuItems,
} from 'src/modules/designStudio/constants/hardCodedData/textureData';

import { UpdateDesignFunction } from '../../../../providers/HistoryProvider';
import { TexturePicker } from '../../TexturePicker';

const FILTER_TITLE = 'Colors';

export const TextureList = ({
  selectedMenuItem,
  updateDesign,
  designConfigCategory,
}: {
  selectedMenuItem?: MenuItemType;
  updateDesign: UpdateDesignFunction;
  designConfigCategory: FeatureCategories;
}) => {
  if (!selectedMenuItem) return null;
  const attrsToMatch = ['style', 'category', 'type'] as (keyof MenuItemType)[];

  const onPress = (textureId: number) => {
    const color = '#ffffff';
    updateDesign({
      category: designConfigCategory,
      update: {
        textureId,
        // Must apply white color to textures that already have colors, otherwise you'll have a color overlay ontop of the texture
        color,
      },
      trackingData: {
        product: designConfigCategory,
        parameter: FILTER_TITLE,
        selection: textureId,
      },
    });
  };

  const items = MenuItems.filter(item =>
    attrsToMatch.every(
      attr => item[attr] === selectedMenuItem[attr] && item.thumbnail,
    ),
  );

  const groupSet = new Set<string>();

  items.forEach(item => {
    if (item.colorGroup) {
      groupSet.add(item.colorGroup);
    }
  });

  const groups = Array.from(groupSet);

  return (
    <TexturePicker
      groups={groups}
      items={items}
      onPress={onPress}
      selectedMenuItem={selectedMenuItem}
      title={FILTER_TITLE}
    />
  );
};
